module.exports = __webpack_public_path__ + "img/10.18a76660.png";